import { useState, useRef, useEffect } from "react";
import { useLanguage } from "../../context/LanguageContext";
import styles from "./LanguageSelector.module.css";

import UkFlagUrl from "../../assets/flags/uk.svg";
import UaFlagUrl from "../../assets/flags/ua.svg";
import RuFlagUrl from "../../assets/flags/ru.svg";

type LangKey = "en" | "ru" | "uk";

const FLAGS: Record<LangKey, string> = {
  en: UkFlagUrl,
  uk: UaFlagUrl,
  ru: RuFlagUrl,
};

export default function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const selectLanguage = (lang: LangKey) => {
    setLanguage(lang);
    setOpen(false);
  };

  return (
    <div className={styles.selectorWrapper} ref={wrapperRef}>
      <button className={styles.selectorButton} onClick={() => setOpen(!open)}>
        <img src={FLAGS[language]} className={styles.flag} alt={language} />
        <span className={styles.currentLabel}>{language.toUpperCase()}</span>
      </button>

      {open && (
        <div className={styles.dropdown}>
          {(["en", "ru", "uk"] as LangKey[]).map((lang) => (
            <div
              key={lang}
              className={`${styles.option} ${language === lang ? styles.active : ""}`}
              onClick={() => selectLanguage(lang)}
            >
              <img src={FLAGS[lang]} className={styles.flag} alt={lang} />
              <span className={styles.label}>{lang.toUpperCase()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
